import { CBContext, CBEventInfo } from "../../codebricks-runtime/CBModels";
import { CodeBrick } from "../../codebricks-runtime/CodeBrick";
import { LayoutGrid } from "../../shared-funcs/LayoutGrid";
import { CBWebUtil } from "../controls/cb_web_util";

export class cc_layout_grid_webcomponent extends HTMLElement {
    ci: web_cc_layout_grid | undefined;
    constructor() {
        super();
    }
    connectedCallback() {
        if(!this.ci) {
            let context = (globalThis as any).codebricks_context;
            let cid = this.getAttribute('cid') as string;
            let name = this.getAttribute('name') as string;
            let dc = this.getAttribute('dc') as string;
                let idx = this.getAttribute('idx') as string;
                let container_id = this.getAttribute('container_id') as string;
            this.ci = new web_cc_layout_grid(context, cid, name, dc, Number(idx), container_id, this);
        }
    }
    disconnectedCallback() {
        if(this.ci) {
            this.ci.destructor();
        }
    }
}
customElements.define('cc-layout-grid', cc_layout_grid_webcomponent);

export class web_cc_layout_grid extends CodeBrick {

    element: HTMLElement;

    constructor(context: CBContext, cid:string, name: string, dc: string, idx: number, container_id: string, element: HTMLElement) {
        super(context, cid, name, dc, idx, container_id);
        this.element = element;
        //let shadowRoot = this.attachShadow({ mode: 'open' });
        this.init_cement();
    }

    async cb_event(input: string, cfg: any, info: CBEventInfo): Promise<void> {
        if(input == "hide") {
            let slot = document.getElementById(this.brick_id);
            if(slot) {
                if(cfg) {
                    slot.style.display = "none";
                }
                else {
                    slot.style.display = "flex";
                }
            }
        }
    }
    cb_initial_cement(cements: { [child_idx: number]: any }) {

        //console.log("cc-layout-grid "+this.brick_id+" initial "+initial+" cb_cement "+JSON.stringify(cements));
        
        //order childs by row and position
        let ordered_childs = LayoutGrid.orderChilds(this.blueprint); 

        let container_style = "";

        if(this.blueprint.ins && this.blueprint.ins.cfg && this.blueprint.ins.cfg.style) {
            for(let v in this.blueprint.ins.cfg.style) {
                container_style += v+':'+this.blueprint.ins.cfg.style[v]+";"
            }
        }

        let classes = '';
        if(this.blueprint.ins && this.blueprint.ins.cfg && this.blueprint.ins.cfg.style_classes) {
            for(let cl in this.blueprint.ins.cfg.style_classes) {
                classes += this.blueprint.ins.cfg.style_classes[cl] + " ";
            }
        }

        let child_classes = '';
        if(this.blueprint.ins && this.blueprint.ins.cfg && this.blueprint.ins.cfg.child_classes) {
            for(let cl in this.blueprint.ins.cfg.child_classes) {
                child_classes += this.blueprint.ins.cfg.child_classes[cl] + " ";
            }
        }

        let at_row = undefined;
        let innerHTML = `<div style="${container_style}" class="cc-layout-grid-container ${classes}" id="${this.brick_id}">`

        
        //TODO calculate md widths to fill gaps for md


        for(let c = 0; c < ordered_childs.length; c++) {
            let sub = ordered_childs[c].sub;
            let cement_idx = ordered_childs[c].p;
            let cement = cements[cement_idx] || {};

            let lop_classes = "";

            let brick = CBWebUtil.BrickHtml(sub, this, cement_idx);

            let prefix = sub.type.split('-')[0];
            if(prefix.indexOf('i') == -1) {

                let lop_style = "";
                
                if(cement) {
                    for(let v in cement) {
                        if(v == "style_classes") {
                            if(cement[v]) {
                                lop_classes = sub.cement[v].join(' ');
                            }
                        }
                        else if(v != "width" && v != "row" && v != "position" && v != "hidden") {
                            lop_style += v+':'+cement[v]+";"
                        }
                    }
                    
                }

                let cols = sub.cement.width || 12;
                let classes = "";

                classes = "w"+cols;

                if(cement && cement.hidden) {
                    classes += " hidden";
                }

                innerHTML += `<div class="cc-layout-grid-cell ${classes}" id="${this.brick_id}$${cement_idx}"><div style="${lop_style}" class="cc-layout-grid-item ${child_classes}${lop_classes}" >${brick}</div></div>`;

            }
            else {
                innerHTML += "<div style='display:none'>"+brick+"</div>";
            }

            if((cement.row || 0) !== at_row) {
                at_row = cement.row || 0;
            }
        }

        innerHTML += `</div>`;

        this.element.innerHTML = innerHTML;
                    
    }
    cb_update_cement(child_idx: number, cement: any, row_idx: number) {

        let child = document.getElementById(this.brick_id+"$"+child_idx);

        if(child) {
            if(cement.hidden) {
                child.classList.add("hidden");
            }
            else {
                child.classList.remove("hidden");
            }
        }

        //If you do child classes, do it on the child of child, the id is on the outer container
        
    }
    cb_status(status: string): void {
    }
    cb_snapshot() {}
}


